module.exports = __webpack_public_path__ + "static/media/split-bedroom.a3f658b4.svg";